<div class="content-bg">
    <div class="main">
        <app-landing-toolbar></app-landing-toolbar>
        <div class="content-privacy">
            <div class="content-text">
                <h1>Política de Tratamiento de Datos Personales</h1>
                <p>
                    En Workbi Services S.A.S (en adelante "Workbi"), con la finalidad de dar cumplimiento a la
                    normatividad vigente sobre protección de datos, conforme a lo establecido en la Ley 1581 del 2012,
                    Decreto 1074 de 2015 y demás disposiciones que las modifiquen, adicionen o complementen, estamos
                    comprometidos con la protección y el correcto uso de los datos personales que recopilamos de
                    nuestros usuarios y Workbies a través de nuestra Plataforma. Esta Política de Tratamiento de Datos
                    Personales (en adelante "Política") regula la recolección, almacenamiento, uso, circulación y
                    supresión de los datos personales recolectados a través de nuestra plataforma.
                </p>
                <ol>
                    <h4>
                        <li>
                            Responsable del Tratamiento de Datos Personales
                        </li>
                    </h4>
                    <p>
                        El responsable del tratamiento de sus datos personales e Workbi Services S.A.S, una sociedad
                        constituida conforme a las leyes de Colombia, identificada con NIT No. 901.812.872-9,
                        domiciliada en la ciudad de Bogotá D.C., cuya actividad principal es conectar a usuarios que
                        necesitan un servicio con personas que prestan dichos servicios (en adelante “Workbies” o
                        “Workbie”) a través de la Plataforma, que está compuesta por nuestra aplicación móvil y sitio
                        web. Para cualquier consulta o reclamación relacionada con sus datos personales, puede
                        contactarnos a través del correo electrónico <a href="mailto:pqrs@workbiservices.com">{{ mail
                            }}</a>.
                    </p>
                    <h4>
                        <li>
                            Definiciones
                        </li>
                    </h4>
                    <p>
                        <b>Autorización:</b> Consentimiento previo, expreso e informado del titular para llevar a cabo
                        el
                        tratamiento de datos personales.
                        <br>
                        <b>Base de Datos Personales:</b> Conjunto organizado de datos personales que sea objeto de
                        tratamiento.
                        <br>
                        <b>Datos de identificación:</b> nombre, número de teléfono, correo electrónico, número de
                        identificación, dirección.
                        <br>
                        <b>Datos de registro:</b> foto del rostro (si aplica), foto del documento de identidad (si
                        aplica),
                        antecedentes judiciales (si aplica).
                        <br>
                        <b>Datos de uso:</b> información sobre el uso de la Plataforma, como solicitudes de servicios,
                        ofertas
                        realizadas por Workbies, y transacciones efectuadas.
                        <br>
                        <b>Datos de pago:</b> detalles del método de pago registrado, incluyendo información bancaria y
                        transacciones.
                        <br>
                        <b>Habeas data:</b> Es el derecho que tiene el Titular de los datos personales de exigir de las
                        administradoras de los mismos el acceso, inclusión, exclusión, corrección,
                        adición, actualización y rectificación de los datos, así como la limitación en su divulgación,
                        publicación o cesión.
                        <br>
                        <b>Responsable del tratamiento:</b> Persona natural o jurídica de carácter público o privado que
                        por sí
                        misma o en asocio con otro u otros decide sobre el tratamiento de datos personales.
                        <br>
                        <b>Titular:</b> Persona natural cuyos datos personales son objeto de tratamiento.
                        <br>
                        <b>Transacción:</b> Cualquier operación o serie de operaciones realizadas en la Plataforma
                        Workbi que
                        implique el intercambio de servicios por parte de un Workbie y una solicitud de servicios por
                        parte de un usuario, incluyendo pero no limitado a la solicitud, oferta, aceptación, y
                        procesamiento de pagos relacionados con dichos servicios.
                        <br>
                        <b>Tratamiento:</b> Cualquier operación o conjunto de operaciones sobre datos personales, como
                        la
                        recolección, almacenamiento, uso, circulación o supresión.
                    </p>
                    <h4>
                        <li>
                            Principios rectores para el tratamiento de los datos personales
                        </li>
                    </h4>
                    <p>
                        Conforme a lo establecido en el título II de la Ley 1581 de 2012, se aplicarán de manera
                        integral los siguientes principios:
                    </p>
                    <ol type="a">
                        <p>
                            <li>
                                <b>Principio de legalidad en materia de Tratamiento de datos:</b> El Tratamiento a que
                                se
                                refiere la Ley 1581 de 2012 es una actividad reglada que debe sujetarse a lo establecido
                                en ella y en las demás disposiciones que la desarrollen;
                            </li>
                            <li>
                                <b>Principio de finalidad:</b> El Tratamiento debe obedecer a una finalidad legítima de
                                acuerdo con la Constitución y la Ley, la cual debe ser informada al Titular;
                            </li>
                            <li>
                                <b>Principio de libertad:</b> El Tratamiento sólo puede ejercerse con el consentimiento,
                                previo, expreso e informado del Titular. Los datos personales no podrán ser obtenidos o
                                divulgados sin previa autorización, o en ausencia de mandato legal o judicial que releve
                                el consentimiento;
                            </li>
                            <li>
                                <b>Principio de veracidad o calidad:</b> La información sujeta a Tratamiento debe ser
                                veraz, completa, exacta, actualizada, comprobable y comprensible. Se prohíbe el
                                Tratamiento de datos parciales, incompletos, fraccionados o que induzcan a error;
                            </li>
                            <li>
                                <b>Principio de transparencia:</b> En el Tratamiento debe garantizarse el derecho del
                                Titular a obtener del Responsable del Tratamiento o del Encargado del Tratamiento, en
                                cualquier momento y sin restricciones, información acerca de la existencia de datos que
                                le conciernan;
                            </li>
                            <li>
                                <b>Principio de acceso y circulación restringida:</b> El Tratamiento se sujeta a los
                                límites que se derivan de la naturaleza de los datos personales, de las disposiciones de
                                la Ley 1581 de 2012 y la Constitución. En este sentido, el Tratamiento sólo podrá
                                hacerse por personas autorizadas por el Titular y/o por las personas previstas en la
                                presente ley;
                                <br>
                                Los datos personales, salvo la información pública, no podrán estar disponibles en
                                Internet u otros medios de divulgación o comunicación masiva, salvo que el acceso sea
                                técnicamente controlable para brindar un conocimiento restringido sólo a los Titulares o
                                terceros autorizados conforme a la presente ley;
                            </li>
                            <li>
                                <b>Principio de seguridad:</b> La información sujeta a Tratamiento por el Responsable
                                del Tratamiento o Encargado del Tratamiento a que se refiere la Ley 1581 de 2012, se
                                deberá manejar con las medidas técnicas, humanas y administrativas que sean necesarias
                                para otorgar seguridad a los registros evitando su adulteración, pérdida, consulta, uso
                                o acceso no autorizado o fraudulento;
                            </li>
                            <li>
                                <b>Principio de confidencialidad:</b> Todas las personas que intervengan en el
                                Tratamiento de datos personales que no tengan la naturaleza de públicos están obligadas
                                a garantizar la reserva de la información, inclusive después de finalizada su relación
                                con alguna de las labores que comprende el Tratamiento, pudiendo sólo realizar
                                suministro o comunicación de datos personales cuando ello corresponda al desarrollo de
                                las actividades autorizadas en la presente ley y en los términos de la misma.
                            </li>
                        </p>
                    </ol>
                    <h4>
                        <li>
                            Finalidades del Tratamiento
                        </li>
                    </h4>
                    <ul>
                        <p>
                            <li>
                                <b>Qué información recopilamos.</b> Recopilamos sobre usted: la información que usted
                                proporciona, la que recopilamos automáticamente y la que obtenemos de otras fuentes. No
                                recopilamos información sobre su origen racial o étnico, opiniones políticas o
                                pertenencia a cualquier asociación política, creencias religiosas o filosóficas,
                                afiliación sindical, datos genéticos o datos relativos a la vida u orientación sexuales
                                de cada persona.
                            </li>
                        </p>
                        <ul>
                            <p>
                                <li>
                                    <b>Información que usted proporciona.</b>
                                </li>
                            </p>
                            <ul>
                                <p>
                                    <li>
                                        <b>Información que el usuario proporciona.</b> Información de registro, que
                                        puede
                                        incluir su nombre completo, número de teléfono y correo electrónico, además,
                                        podemos recopilar con fines de seguridad: una foto de su rostro y su número de
                                        documento de identidad cuando aplique y la ley lo permita o lo exija. Si no
                                        facilita esta información, no podrá registrarse como usuario. Si lo desea, puede
                                        incluir también su dirección, su sexo y una foto para su perfil.
                                    </li>
                                    <li>
                                        <b>Información que el Workbie proporciona.</b> Información de registro, que
                                        puede
                                        incluir su nombre completo, número de teléfono, número de identificación, correo
                                        electrónico, dirección Y sexo (opcional), además, podemos recopilar con fines de
                                        seguridad pruebas de identidad solicitando una foto de su rostro y una foto de
                                        su documento de identidad. Cuando la ley lo permita o lo exija, podremos
                                        recopilar además, información sobre antecedentes judiciales y de otro tipo. Si
                                        no brinda esta información, no podrá registrarse como Workbie.
                                    </li>
                                    <li>
                                        <b>Contenido generado por el usuario.</b> Usted puede generar contenido en la
                                        Plataforma con opiniones, calificaciones y reseñas.
                                    </li>
                                    <li>
                                        Información que usted nos envíe que incluya chats, correos electrónicos,
                                        grabaciones de llamadas telefónicas y otros metadatos relacionados.
                                    </li>
                                </p>
                            </ul>
                            <p>
                                <li>
                                    <b>Información que recopilamos automáticamente</b>
                                </li>
                            </p>
                            <ul>
                                <p>
                                    <li>
                                        <b>Información sobre la ubicación.</b> Nosotros recogemos los datos de
                                        localización de
                                        los usuarios y Workbies para hacer posible la ejecución del servicio solicitado
                                        por el usuario; siempre y cuando sea necesario ejecutar el servicio de manera
                                        presencial, proporcionar asistencia al usuario, garantizar la seguridad,
                                        detectar el fraude y cumplir con los requerimientos legales. Recopilamos
                                        información sobre la ubicación precisa del dispositivo en el cual está haciendo
                                        uso de la Plataforma, en primer y segundo plano, en función de la configuración
                                        de la Plataforma y los permisos del dispositivo de dos maneras, (i) desde el
                                        momento en que se inicia la solicitud del servicio y hasta cuando el Workbie
                                        termina la ejecución de la solicitud; y (ii) con fines de recolección de datos
                                        para la toma de decisiones automatizada (emparejamiento).
                                    </li>
                                    <li>
                                        <b>Información sobre la transacción.</b> Recopilamos información sobre las
                                        transacciones relacionadas con la solicitud creada en Workbi, como el importe
                                        cobrado, la información del pago, la fecha y hora en que se ejecutó la solicitud
                                        y la dirección e información del lugar donde se ejecutó (si aplica).
                                    </li>
                                    <li>
                                        <b>Información de uso de la plataforma.</b> Recopilamos datos del uso que usted
                                        le da a la Plataforma, que incluye las funciones usadas, las páginas visitadas y
                                        otras actividades de la Plataforma con la finalidad de garantizar su seguridad,
                                        verificar que no incurra en infracciones y mejorar la Plataforma.
                                    </li>
                                </p>
                            </ul>
                            <p>
                                <li>
                                    <b>Información que recopilamos automáticamente.</b>
                                </li>
                            </p>
                            <ul>
                                <p>
                                    <li>
                                        <b>Servicios de terceros.</b> Podemos obtener información sobre usted de
                                        terceros, por ejemplo, si decide usar una
                                        aplicación de terceros para registrarse en la Plataforma como Google. También
                                        podemos obtener información de la pasarela de pagos cuando el usuario realice el
                                        pago de la solicitud de servicios.
                                    </li>
                                </p>
                            </ul>
                        </ul>
                        <p>
                            <li>
                                <b>Los datos personales recopilados se utilizan para:</b>
                            </li>
                        </p>
                        <ul>
                            <p>
                                <li>
                                    Facilitar la conexión entre usuarios y Workbies.
                                </li>
                                <li>
                                    Permitirle a los usuarios tener una cuenta en la Plataforma, solicitar y/o ofrecer
                                    servicios a través de ella.
                                </li>
                                <li>
                                    Verificar la identidad y antecedentes de los Workbies.
                                </li>
                                <li>
                                    Prevenir situaciones de riesgo o peligro, fraudes e infracciones.
                                </li>
                                <li>
                                    Enviar información necesaria como notificaciones, recibos, entre otros.
                                </li>
                                <li>
                                    Gestionar el registro y mantenimiento de cuentas de usuario.
                                </li>
                                <li>
                                    Procesar y gestionar pagos y transacciones.
                                </li>
                                <li>
                                    Llevar un registro histórico de la información, con fines de satisfacción al usuario
                                    desarrollando análisis sobre los intereses y necesidades; brindando de esta manera
                                    un mejor servicio.
                                </li>
                                <li>
                                    Segmentar el mercado.
                                </li>
                                <li>
                                    Mejorar y personalizar la experiencia del usuario en la Plataforma.
                                </li>
                                <li>
                                    Realizar análisis de datos, desarrollo y aprendizaje automático.
                                </li>
                                <li>
                                    Recolectar sus opiniones, calificaciones o reseñas.
                                </li>
                                <li>
                                    Toma de decisiones automatizada (emparejamiento).
                                </li>
                                <li>
                                    Enviar comunicaciones relacionadas con el uso de la Plataforma, incluyendo
                                    notificaciones de servicio y actualizaciones de seguridad.
                                </li>
                                <li>
                                    Enviar comunicaciones con avisos publicitarios, llamadas o chats con fines
                                    publicitarios, entre otros.
                                </li>
                                <li>
                                    Proteger los derechos de las personas.
                                </li>
                                <li>
                                    Cumplir con las obligaciones legales y reglamentarias aplicables.
                                </li>
                            </p>
                        </ul>
                    </ul>
                    <h4>
                        <li>
                            Transferencia y Divulgación de Datos Personales
                        </li>
                    </h4>
                    <p>
                        Workbi puede compartir sus datos personales con terceros únicamente en los siguientes casos:
                    </p>
                    <ul>
                        <p>
                            <li>
                                <b>Proveedores de servicios:</b> Para la prestación de servicios en nuestro nombre,
                                tales como procesamiento de pagos y verificación de antecedentes.
                            </li>
                            <li>
                                <b>Obligaciones legales:</b> Para cumplir con requerimientos legales, regulatorios o
                                judiciales.
                            </li>
                            <li>
                                <b>Protección de derechos:</b> Para proteger los derechos, propiedad o seguridad de
                                Workbi, nuestros usuarios o terceros.
                            </li>
                        </p>
                    </ul>
                    <h4>
                        <li>
                            Derechos del Titular de los Datos
                        </li>
                    </h4>
                    <p>
                        Los titulares de los datos personales tienen los siguientes derechos:
                    </p>
                    <ul>
                        <p>
                            <li>
                                <b>Acceso:</b> Conocer los datos personales que tenemos y el uso que hacemos de ellos.
                            </li>
                            <li>
                                <b>Rectificación:</b> Solicitar la corrección de datos inexactos o incompletos.
                            </li>
                            <li>
                                <b>Cancelación:</b> Solicitar la eliminación de los datos personales cuando no sean
                                necesarios para las finalidades para las cuales fueron recopilados.
                            </li>
                            <li>
                                <b>Oposición:</b> Oponerse al tratamiento de sus datos personales por motivos legítimos.
                            </li>
                            <li>
                                <b>Revocación del consentimiento:</b> Retirar el consentimiento otorgado para el
                                tratamiento de sus datos personales.
                            </li>
                        </p>
                    </ul>
                    <p>
                        Para ejercer estos derechos, puede contactarnos a través del correo electrónico <a
                            href="mailto:pqrs@workbiservices.com">{{ mail }}</a>, indicando claramente su solicitud.
                    </p>
                    <h4>
                        <li>
                            Seguridad de los Datos Personales
                        </li>
                    </h4>
                    <p>
                        Implementamos medidas de seguridad técnicas y organizativas apropiadas para proteger los datos
                        personales contra acceso no autorizado, pérdida, destrucción o alteración. Estas medidas
                        incluyen el uso de tecnologías de encriptación y la restricción de acceso a los datos personales
                        a personal autorizado.
                    </p>
                    <h4>
                        <li>
                            Conservación de los Datos Personales
                        </li>
                    </h4>
                    <p>
                        Conservamos los datos personales durante el tiempo necesario para cumplir con las finalidades
                        para las cuales fueron recopilados, incluyendo cualquier obligación legal, contable o de
                        reporte.
                    </p>
                    <h4>
                        <li>
                            Autorización del tratamiento de datos personales
                        </li>
                    </h4>
                    <p>
                        Los visitantes (usuarios y Workbies) de la Plataforma, deben registrarse y autorizar el
                        tratamiento de datos personales para poder hacer uso de la misma. La política la encuentra en
                        una casilla al momento de registrarse, deberá abrirla, leerla y aceptarla para poder usar la
                        Plataforma de Workbi Services S.A.S.
                    </p>
                    <h4>
                        <li>
                            Cambios en la Política
                        </li>
                    </h4>
                    <p>
                        Workbi se reserva el derecho de modificar esta Política en cualquier momento. Las modificaciones
                        serán publicadas en nuestra Plataforma o mediante el envío de una notificación por correo
                        electrónico y entrarán en vigor a partir de la fecha de publicación. Le recomendamos revisar
                        periódicamente esta Política para estar informado sobre cómo protegemos sus datos personales.
                    </p>
                    <h4>
                        <li>
                            Datos de Menores de Edad
                        </li>
                    </h4>
                    <p>
                        El uso de la Plataforma Workbi no está dirigido para público menor de edad, por lo que no
                        recolectamos intencionalmente datos de menores de edad sin el
                        consentimiento de sus representantes legales. Si se detecta que hemos recopilado datos
                        personales de un menor de edad sin dicho consentimiento, tomaremos las medidas necesarias para
                        eliminar dicha información.
                    </p>
                    <h4>
                        <li>
                            Procedimiento para el Ejercicio de Derechos
                        </li>
                    </h4>
                    <p>
                        Para ejercer sus derechos, los titulares pueden enviar una solicitud clara y detallada a nuestro
                        correo electrónico <a href="mailto:pqrs@workbiservices.com">{{ mail }}</a>. Responderemos en un
                        plazo
                        máximo de 15 días hábiles, conforme a lo estipulado por la ley.
                    </p>
                    <h4>
                        <li>
                            Contacto
                        </li>
                    </h4>
                    <p>
                        Si tiene preguntas, comentarios o inquietudes sobre esta Política o el tratamiento de sus datos
                        personales, puede contactarnos a través del correo electrónico <a
                            href="mailto:pqrs@workbiservices.com">{{ mail }}</a>.
                    </p>
                </ol>
            </div>
        </div>
    </div>
    <app-landing-footer></app-landing-footer>
</div>